import { useState } from "react";
import { Outlet } from "react-router-dom";
import { PortalSidebar } from "@/components/portal/PortalSidebar";
import { PortalTopBar } from "@/components/portal/PortalTopBar";

/**
 * Portal shell (CE-24). Wraps every guarded portal route in the shared
 * sidebar + top bar the SPA lost at the CE-14 cutover. Rendered by PortalGuard
 * (which supplies auth + PortalProvider); <Outlet/> hosts the matched page.
 *
 * Below `md` the sidebar is an off-canvas drawer the top bar's menu button
 * opens (CE-135); from `md` up it is the fixed column it always was.
 */
export default function PortalLayout() {
  const [navOpen, setNavOpen] = useState(false);

  return (
    <div className="flex min-h-screen bg-surface-2">
      <PortalSidebar open={navOpen} onClose={() => setNavOpen(false)} />
      <div className="flex-1 flex flex-col min-w-0">
        <PortalTopBar navOpen={navOpen} onOpenNav={() => setNavOpen(true)} />
        <main className="flex-1 p-4 md:p-6 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
